import React from "react"
import type { ModeloIzzaGPTModel } from "../models/modeloIzzaGPTModel"
import { ModeloIzzaGPTInicial } from "../models/modeloIzzaGPTModel"
import type { ModeloIzzaGPTActionModel } from "./modeloIzzaGPTActions"

interface ModeloIzzaGPTContextValue {
    dados: ModeloIzzaGPTModel
    dispatch: React.Dispatch<ModeloIzzaGPTActionModel>
    erroCarregamento: string | null
    salvar: () => Promise<void>
}

export const ModeloIzzaGPTContext = React.createContext<ModeloIzzaGPTContextValue>({
    dados: ModeloIzzaGPTInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    salvar: async () => undefined,
})
